<template>
  <div>
    <template v-if="action == 'view'">
      <div class="table-settings mb-4" v-if="allData.count > 0">
        <div class="row align-items-center justify-content-between">
          <div class="col col-md-6 col-lg-3 col-xl-4">
            <!-- <div class="input-group">
                        <span class="input-group-text" id="basic-addon2"><span class="fa fa-search"></span></span>
                        <input v-model="q" type="search" class="form-control" id="exampleInputIconLeft" placeholder="Search" aria-label="Search" aria-describedby="basic-addon2">
                    </div> -->
          </div>
          <!-- <div class="col col-md-6 col-lg-3 col-xl-4 text-right">
<a href="https://5ineprojects.com/Rapidea/backend/api/user_export.php" class="btn btn-primary" download>Download Excel</a>
                </div> -->
        </div>
      </div>
      <div class="card border-light shadow-sm mb-4">
        <div
          style="
            position: absolute;
            margin-top: 120px;
            z-index: 1;
            width: max-content;
            left: 50%;
            transform: translate(-50%, 0%);
          "
          v-if="
            !permissions.find((e) => e.permission_name == 'View Site Users')
          "
        >
          <span style="color: red"
            ><i class="mr-2 fa fa-eye-slash"></i>You dont have the viewing
            permission.</span
          >
        </div>
        <div
          :style="
            !permissions.find((e) => e.permission_name == 'Export Site Users')
              ? 'filter: blur(4px); pointer-events: none;'
              : ''
          "
          class="card-body"
          style="overflow-x: scroll"
          v-if="loading == false && (allData.count > 0 || q != '')"
        >
          <div class="d-flex flex-row-reverse pb-3" style="gap: 10px">
            <button
              :disabled="
                !permissions.find(
                  (e) => e.permission_name == 'Active/Inactive Site Users'
                )
              "
              @click.prevent="exportData"
              class="btn btn-sm btn-outline-primary"
            >
              <i class="fa fa-download mx-2"></i>EXPORT
            </button>
            <input
              @input="search"
              v-model="q"
              type="text"
              placeholder="Search By Order ID"
              class="form-control w-25"
            />
            <div class="d-flex flex-row align-items-center" style="gap: 10px">
              <span>Start Date: </span>
              <input
                type="date"
                @input="filterByDate"
                v-model="start_date"
                class="form-control"
                style="width: max-content"
              />
            </div>
            <div class="d-flex flex-row align-items-center" style="gap: 10px">
              <span>End Date: </span>
              <input
                type="date"
                @input="filterByDate"
                v-model="end_date"
                class="form-control"
                style="width: max-content"
              />
            </div>
          </div>
          <div style="overflow-x: scroll">
            <table class="table table-hover">
              <thead class="thead-light">
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Mobile</th>
                  <th>Email</th>
                  <th>
                    Registration Date
                    <i
                      :class="
                        sortByRegDate
                          ? 'fa fa-chevron-down'
                          : 'fa fa-chevron-up'
                      "
                      @click.prevent="SortByReg"
                      style="cursor: pointer"
                    ></i>
                  </th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody v-if="allData.count > 0">
                <tr v-for="(data, key) in allData.data" :key="key">
                  <td>
                    <a href="#" class="font-weight-bold">
                      {{ key + 1 }}
                    </a>
                  </td>
                  <td>
                    <span class="font-weight-normal">{{ data.username }}</span>
                  </td>
                  <td>{{ data.mobile }}</td>
                  <td>{{ data.email }}</td>
                  <td>
                    {{ formatDateTime(data.udate) }}
                  </td>
                  <td>
                    <span class="font-weight-bold">
                      <button
                        :disabled="
                          !permissions.find(
                            (e) =>
                              e.permission_name == 'Active/Inactive Site Users'
                          )
                        "
                        class="btn btn-danger btn-xs"
                        href="#"
                        @click="
                          update('mss_site_user', 1, data.id);
                          data.status = 1;
                        "
                        v-if="data.status == 0"
                      >
                        Inactive
                      </button>
                      <button
                        :disabled="
                          !permissions.find(
                            (e) =>
                              e.permission_name == 'Active/Inactive Site Users'
                          )
                        "
                        class="btn btn-success btn-xs"
                        @click="
                          update('mss_site_user', 0, data.id);
                          data.status = 0;
                        "
                        v-if="data.status == 1"
                      >
                        Active
                      </button>
                      <span
                        class="badge badge-pill"
                        style="background-color: #fff3cd; color: #856404; border: 1px solid #ffc107;"
                        v-if="data.status == 2"
                      >
                        <i class="fa fa-exclamation-triangle mr-1"></i>Not Verified
                      </span>
                    </span>
                  </td>
                  <td>
                    <!-- <a class="btn btn-info btn-xs hide" href="#"><span class="fa fa-eye mr-2"></span>View Details</a> -->
                    <div class="btn-group">
                      <router-link
                        :style="
                          permissions.find(
                            (e) => e.permission_name == 'Edit Site Users'
                          )
                            ? ''
                            : 'opacity: 0.4;'
                        "
                        class="btn btn-primary btn-xs"
                        :to="
                          permissions.find(
                            (e) => e.permission_name == 'Edit Site Users'
                          )
                            ? {
                                name: 'index',
                                params: {
                                  page: page,
                                  action: 'edit',
                                  id: data.id,
                                },
                              }
                            : ''
                        "
                        ><span class="fa fa-edit mr-2"></span>Edit</router-link
                      >

                      <button
                        :disabled="
                          !permissions.find(
                            (e) => e.permission_name == 'Abandoned Cart'
                          )
                        "
                        @click.prevent="openAbandonedCart(data.id)"
                        class="btn btn-warning btn-xs"
                        href="#"
                      >
                        <span class="fa fa-trash-alt mr-2"></span>Abandoned Cart
                      </button>

                      <button
                        :disabled="
                          !permissions.find(
                            (e) => e.permission_name == 'Remove Site Users'
                          )
                        "
                        @click.prevent="remove(data.id)"
                        class="btn btn-danger btn-xs"
                        href="#"
                      >
                        <span class="fa fa-trash-alt mr-2"></span>Remove
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td class="text-center" colspan="5">No record found</td>
                </tr>
              </tbody>
            </table>
          </div>
          <Modal width="75%" height="700px" name="Abandoned Cart Modal">
            <div class="abandoned-modal">
              <!-- Header -->
              <div class="modal-header-custom">
                <div>
                  <h3 class="mb-0">
                    Abandoned Cart
                    <span class="cart-count-badge">
                      {{ cartData.length }}
                    </span>
                  </h3>
                  <small class="text-muted">
                    User abandoned cart details
                  </small>
                </div>

                <button
                  class="close-modal-btn"
                  @click.prevent="
                    $modal.hide('Abandoned Cart Modal');
                    cartData = [];
                  "
                >
                  ✕
                </button>
              </div>

              <!-- Empty State -->
              <div v-if="!cartData || cartData.length === 0" class="empty-cart">
                No abandoned carts found
              </div>

              <!-- Cart List -->
              <div v-for="cart in cartData" :key="cart.id" class="cart-card">
                <!-- Top -->
                <div class="cart-header">
                  <div class="cart-left">
                    <img
                      v-if="
                        cart.selected_product &&
                        cart.selected_product.product_category &&
                        cart.selected_product.product_category.images &&
                        cart.selected_product.product_category.images.length
                      "
                      :src="
                        cart.selected_product.product_category.images[0]
                          .image_url
                      "
                      class="main-product-image"
                      @click="
                        previewImage =
                          cart.selected_product.product_category.images[0]
                            .image_url
                      "
                    />
                  </div>

                  <div class="cart-right">
                    <div
                      class="d-flex justify-content-between align-items-start"
                    >
                      <div>
                        <h4 class="product-title">
                          {{
                            cart.selected_product.product_category.category_name
                          }}
                        </h4>

                        <div class="cart-meta">Cart ID : #{{ cart.id }}</div>

                       <div class="cart-meta">
  Added :
  {{ new Date(cart.createdDate).toLocaleDateString() }}

  <span class="days-ago-badge">
    {{
      getDaysAgo(cart.createdDate)
    }}
  </span>
</div>
                      </div>

                      <div class="price-box">₹{{ cart.total_amount }}</div>
                    </div>

                    <!-- Summary -->
                    <div class="summary-grid">
                      <div class="summary-item">
                        <span>Quantity</span>
                        <strong>{{ cart.qty }}</strong>
                      </div>

                      <div class="summary-item">
                        <span>Order Type</span>
                        <strong>{{ cart.ord_type }}</strong>
                      </div>

                      <div class="summary-item">
                        <span>Status</span>
                        <strong class="text-warning"> Abandoned </strong>
                      </div>

                      <div class="summary-item">
                        <span>Amount</span>
                        <strong>₹{{ cart.amount }}</strong>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Uploaded Images -->
                <div
                  v-if="cart.uploaded_images && cart.uploaded_images.length"
                  class="uploaded-section"
                >
                  <h5 class="section-title">Uploaded Design Files</h5>

                  <div class="uploaded-images-grid">
                    <img
                      v-for="img in cart.uploaded_images"
                      :key="img.id"
                      :src="img.image_url"
                      class="uploaded-image"
                      @click="previewImage = img.image_url"
                    />
                  </div>
                </div>

                <!-- Options -->
                <div class="options-wrapper">
                  <div class="options-header">
                    <h5 class="options-title">Selected Product Options</h5>
                  </div>

                  <div class="options-body">
                    <div
                      v-for="option in cart.selected_product.product_options"
                      :key="option.id"
                      class="option-row"
                    >
                      <div class="option-left">
                        {{ option.name }}
                      </div>

                      <div class="option-right">
                        {{
                          getOptionValue(
                            cart.selected_product.product_option_values,
                            option.id
                          )
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Image Preview -->
              <div
                v-if="previewImage"
                class="image-preview-overlay"
                @click="previewImage = null"
              >
                <img :src="previewImage" class="preview-image" />
              </div>
            </div>
          </Modal>
          <!-- <div class="card-footer px-3 border-0 d-flex align-items-center justify-content-between">
                <nav aria-label="Page navigation example">
                    <ul class="pagination mb-0">
                        <template v-for="(paginate,key) in allData.links">
                            <li :key="key" class="page-item" :class="{'active': paginate.active}" v-if="paginate.url">
                                <a class="page-link" @click="viewAllUrl=paginate.url;allDatas(false)" v-html="paginate.label"></a>
                            </li>
                        </template>
                    </ul>
                </nav>
                <div class="font-weight-bold small">Page <b>{{allData.current_page}}</b> of <b>{{allData.last_page}}</b> page Total record <b>{{allData.total}}</b></div>
            </div> -->
        </div>
        <div class="card-body text-center" v-else>
          <div v-if="loading">loading...</div>
          <div v-else>
            <!-- <InlineSvg name="nopage"></InlineSvg> -->
            <div>
              <h3>Add and manage your {{ page }}</h3>
              <p>
                This is where you’ll add {{ page }} and manage your website. You
                can also improve your seo for {{ page }} by adding.
              </p>
              <router-link
                :to="{ name: 'index', params: { page: page, action: 'add' } }"
                class="btn btn-primary"
                type="button"
                >Add {{ page }}</router-link
              >
              <br /><br /><br />
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="row">
        <div class="col-12 col-xl-8">
          <div class="card card-body bg-white border-light shadow-sm mb-4">
            <h2 class="h5 mb-4">General information</h2>
            <div class="row">
              <!-- <div class="col-md-6 mb-3">
                                <MssInput v-model="form.linkname" placeholder="Enter Page Link" required></MssInput>
                            </div> -->
              <div class="col-md-6 mb-3">
                <MssInput
                  v-model="form.username"
                  placeholder="Enter Fullname"
                  required
                ></MssInput>
              </div>
              <div class="col-md-6 mb-3">
                <MssInput
                  v-model="form.mobile"
                  placeholder="Enter Mobile Number"
                  required
                ></MssInput>
              </div>
              <div class="col-md-6 mb-3">
                <MssInput
                  v-model="form.email"
                  placeholder="Enter Email"
                  required
                ></MssInput>
              </div>
              <div class="col-md-6 mb-3" v-if="action == 'add'">
                <MssInput
                  v-model="form.pass"
                  placeholder="Enter password"
                  required
                ></MssInput>
              </div>
              <div class="col-md-6 mb-3">
                <MssInput
                  v-model="form.state"
                  placeholder="Enter State name"
                  required
                ></MssInput>
              </div>
              <div class="col-md-6 mb-3">
                <MssInput
                  v-model="form.city"
                  placeholder="Enter City Name"
                  required
                ></MssInput>
              </div>
              <div class="col-md-6 mb-3">
                <MssInput
                  v-model="form.zip"
                  placeholder="Enter Pincode"
                  required
                ></MssInput>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-xl-4 sidebar-stricky">
          <div class="card card-body bg-white border-light shadow-sm mb-4">
            <h2 class="h5 mb-4">Visibility</h2>
            <div class="row">
              <div class="col-md-12 mb-3">
                <MssInput
                  type="switch"
                  v-model="form.status"
                  placeholder="Visible this page to all"
                ></MssInput>
              </div>
              <div class="col-md-12 mb-3">
                <div>
                  <button
                    @click="submit"
                    class="btn btn-info btn-block"
                    v-if="action == 'add'"
                  >
                    Publish
                  </button>
                  <button
                    @click="submit"
                    class="btn btn-success btn-block"
                    v-else
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import axios from "axios";
import $ from "jquery";

export default {
  components: {},
  props: ["page", "action", "id"],
  data() {
    return {
      start_date: null,
      end_date: this.formatDate(new Date()),
      sortByRegDate: true,
      isEditor: true,
      q: "",
      loading: false,
      allData: [],
      cartData: [],
      previewImage: null,
      form: {
        id: null,
        status: true,
        type: "add_user",
        username: "",
        email: "",
        mobile: "",
        password: "",
        state: "",
        city: "",
        zip: "",
      },
      editSEO: false,
      defaultSEO: true,
      pageList: [],
      fullToolbar: [
        [{ font: [] }],
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        [{ size: ["small", false, "large", "huge"] }],
        ["bold", "italic", "underline", "strike"],
        [{ align: [false, "justify", "center", "right"] }],
        //[{ 'header': 1 }, { 'header': 2 }],
        //['blockquote', 'code-block'],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        //[{ 'script': 'sub'}, { 'script': 'super' }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ color: [] }, { background: [] }],
        ["link", "image", "video", "formula"],
        //[{ 'direction': 'rtl' }],
        ["clean"],
      ],
      viewAllUrl: "",
      tempData: [],
      permissions: null,
    };
  },
  methods: {

  formatDateTime(dateStr) {
    if (!dateStr) return '-';
    var date = new Date(dateStr.replace(' ', 'T') + 'Z');
    if (isNaN(date.getTime())) return dateStr;
    date.setUTCHours(date.getUTCHours() + 9);
    date.setUTCMinutes(date.getUTCMinutes() + 30);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();
    let hours = date.getUTCHours();
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    return `${day}/${month}/${year}, ${String(hours).padStart(2, '0')}:${minutes} ${ampm}`;
  },

  getDaysAgo(date) {
  const created = new Date(date);
  const today = new Date();

  const diffTime = today - created;

  const diffDays = Math.floor(
    diffTime / (1000 * 60 * 60 * 24)
  );

  if (diffDays === 0) {
    return "Today";
  }

  if (diffDays === 1) {
    return "1 day ago";
  }

  return `${diffDays} days ago`;
    },

    getOptionValue(values, optionId) {
      const found = values.find(function (v) {
        return v.opt_id == optionId;
      });

      return found ? found.name : "";
    },

    openAbandonedCart(userId) {
      console.log("openAbandonedCart", userId);

      var ev = this;

      var param = {
        uid: userId,
        type: "fetchAbandonedCart",
      };

      axios({
        method: "POST",
        url: this.$root.URL_ROOT + "updatedApiForProducts.php",
        data: param,
      }).then(function (response) {
        console.log(response.data);

        ev.cartData = response.data.data;

        ev.$modal.show("Abandoned Cart Modal");
      });
    },

    search() {
      const ev = this;
      clearTimeout(this.debounce_timer);
      this.debounce_timer = setTimeout(() => {
        ev.loader = true;
        let data = [];
        const new_data = [...ev.tempData];
        if (ev.q != "") {
          data = new_data.map((e) => {
            if (
              (e.username && e.username.includes(ev.q)) ||
              (e.mobile && e.mobile.includes(ev.q))
            ) {
              return e;
            }
            return null;
          });
        } else {
          data = new_data;
        }
        ev.allData.data = data.filter((e) => e != null);
        ev.loader = false;
      }, 300);
    },

    filterByDate() {
      const ev = this;
      const startDate = new Date(ev.start_date);
      const endDate = new Date(ev.end_date);
      ev.loader = true;
      let data = [];
      const new_data = [...ev.tempData];
      if (startDate || endDate) {
        console.log("Filter");
        data = new_data.map((e) => {
          const order_date = new Date(e.udate);
          if (startDate != "Invalid Date" && endDate) {
            if (startDate <= order_date && endDate >= order_date) return e;
          } else if (endDate && startDate == "Invalid Date") {
            if (endDate >= order_date) return e;
          } else if (startDate != "Invalid Date") {
            if (startDate <= order_date) return e;
          }
          return null;
        });
      } else {
        console.log("notFilter");
        data = new_data;
      }
      ev.allData.data = data.filter((e) => e != null);
      ev.loader = false;
    },
    formatDate(today) {
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
      const day = String(today.getDate()).padStart(2, "0");
      const formattedDate = `${year}-${month}-${day}`;
      return formattedDate;
    },
    async exportData() {
      const headings = [
        "Name",
        "Mobile",
        "Email",
        "Registration Date",
        "Status",
      ];
      const formattedData = this.allData.data.map((e) => {
        return [
          e.username,
          e.mobile,
          e.email,
          new Date(e.udate).toLocaleDateString(),
          e.status == 1 ? "Active" : e.status == 2 ? "Not Verified" : "Inactive",
        ];
      });
      const csvData = await Promise.all(formattedData);
      let csvContent = "data:text/csv;charset=utf-8,";
      const heading = headings.join(",");
      csvContent += heading + "\r\n";
      csvData.forEach((row) => {
        const csvRow = row.join(",");
        csvContent += csvRow + "\r\n";
      });
      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "shape_n_print_users_data.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    SortByReg() {
      this.sortByRegDate = !this.sortByRegDate;
      this.allDatas();
    },
    update(table, status, id) {
      var param = {
        id: id,
        status: status,
        table: table,
        type: "commonStatus",
      };
      axios({
        method: "POST",
        url: this.$root.URL_ROOT + "api.php",
        data: param,
      }).then(function (response) {
        var data = response.data;
        console.log("status", data);
      });
    },
    addInit() {
      this.getUnderof();
      this.reset();
    },
    editInit() {
      this.getDetail();
      this.getUnderof();
    },
    viewInit() {
      this.viewAllUrl = this.URL_ROOT + "admin/" + this.page + "/all";
      this.allDatas(true);
    },
    reset() {
      this.form = {
        id: null,
        status: true,
        type: "add_user",
        username: "",
        email: "",
        mobile: "",
        pass: "",
        state: "",
        city: "",
        zip: "",
      };
    },
    getUnderof() {
      var pList = [];
      pList.push({ label: "Primary Menu", code: 0 });
      $.ajax({
        method: "GET",
        url:
          this.URL_ROOT +
          "admin/" +
          this.page +
          "/allpage/?field=heading,id,underof",
        success: (response) => {
          if (response.status == "success") {
            console.log(response.data);
            $.each(response.data, function (key, param) {
              //console.log(param,key);
              pList.push({ label: param.heading, code: param.id });
            });
          }
          this.pageList = pList;
        },
      });
      /**
             if(this.action=="add"){
                this.from.lorder = response.length+1;
            } */
    },
    getDetail() {
      var ev = this;
      var param = {
        uid: this.id,
        type: "userDetail",
      };
      axios({
        method: "POST",
        url: this.$root.URL_ROOT + "api.php",
        data: param,
      }).then(function (response) {
        console.log(response.data.data);
        var data = response.data;
        ev.form = data.data;
      });
    },
    allDatas() {
      var ev = this;
      axios({
        method: "POST",
        url: this.$root.URL_ROOT + "api.php",
        data: {
          type: "site_user",
        },
      }).then(function (response) {
        let data = response.data;
        if (ev.sortByRegDate) {
          data = {
            ...response.data,
            data: response.data.data.sort((a, b) => {
              var c = new Date(a.udate);
              var d = new Date(b.udate);
              return d - c;
            }),
          };
        }
        ev.allData = data;
        ev.allData.data = data.data.filter((e) => e.status != 2);
        ev.allData.count = ev.allData.data.length;
        ev.tempData = ev.allData.data;
      });
    },
    submit() {
      var ev = this;

      if (this.form.username === "") {
        this.$toasted.global.error({
          message: "Please enter Full Name",
        });
      } else if (this.form.email === "") {
        this.$toasted.global.error({
          message: "Please enter Email",
        });
      } else if (this.form.mobile === "") {
        this.$toasted.global.error({
          message: "Please enter mobile",
        });
      } else if (this.form.pass === "") {
        this.$toasted.global.error({
          message: "Please enter password",
        });
      } else if (this.form.state === "") {
        this.$toasted.global.error({
          message: "Please enter State",
        });
      } else if (this.form.city === "") {
        this.$toasted.global.error({
          message: "Please enter City",
        });
      } else if (this.form.zip === "") {
        this.$toasted.global.error({
          message: "Please enter Pincode",
        });
      } else {
        var status = "";
        if (ev.form.status == true) {
          status = 1;
        } else {
          status = 0;
        }
        let formData = new FormData();
        if (this.action == "edit") {
          this.form.type = "edit_user";
          formData.append("uid", this.id);
        }
        formData.append("fullname", ev.form.username);
        formData.append("mobile", ev.form.mobile);
        formData.append("email", ev.form.email);
        formData.append("password", ev.form.pass);
        formData.append("state", ev.form.state);
        formData.append("city", ev.form.city);
        formData.append("pincode", ev.form.zip);
        formData.append("status", status);
        formData.append("type", ev.form.type);
        axios({
          method: "POST",
          url: this.$root.URL_ROOT + "api.php",
          data: formData,
        }).then(function (response) {
          var data = response.data;
          console.log(response);
          if (data.status == "success") {
            ev.$swal({
              toast: true,
              position: "top-end",
              timer: 5000,
              icon: "success",
              timerProgressBar: true,
              title: "Action perform successfully",
            });
            //  window.location.href = 'index/'+ev.page;
            ev.$router.push({
              name: "index",
              params: {
                page: ev.page,
              },
            });
          } else {
            setTimeout(() => ev.$swal(data.msg), 1000);
          }
        });
      }
    },
    remove(id) {
      var self = this;
      var param = {
        id: id,
        table: "mss_site_user",
        type: "commonDelete",
      };
      this.$swal({
        title: "Delete this ?",
        text: "Are you sure? You won't be able to revert this!",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#f00",
        confirmButtonText: "Yes, Delete it!",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          axios({
            method: "POST",
            url: this.$root.URL_ROOT + "api.php",
            data: param,
          }).then(function (response) {
            var data = response.data;
            self.allDatas();
            console.log("commonDelete", data);
          });
        }
      });
    },
  },
  mounted() {
    if (localStorage.getItem("permissions")) {
      const permissionsLS = localStorage.getItem("permissions");
      const permission = JSON.parse(permissionsLS);
      console.log("sadfgf", permission);
      this.permissions = permission.filter(
        (e) => e.section == "SITE USERS" && e.has_permission == true
      );
    }
    if (this.action == "view") {
      this.viewInit();
    } else if (this.action == "edit" && this.id > 0) {
      this.editInit();
    } else if (this.action == "add") {
      this.addInit();
    }
  },
  watch: {
    action: function (val) {
      if (val == "view") {
        this.viewInit();
      } else if (val == "edit" && this.id > 0) {
        this.editInit();
      } else if (val == "add") {
        this.addInit();
      }
    },
    // 'form.linkname': function() {
    //     //var text = val.replace(' ', "+")
    //     //this.form.linkname = this.limitedword(text.replace(/\W/g, "+"),20);
    // },'form.pbody': function(val) {
    //     if(this.defaultSEO){
    //         this.form.meta_description = this.limitedword(this.striphtml(val),150);
    //     }
    // },
    // 'form.heading': function(val) {
    //     if(this.defaultSEO){
    //         this.form.meta_title = this.limitedword(val,20);
    //     }
    // },
    // 'loading': function(val) {
    //     if(val){
    //         this.$swal.showLoading();
    //     }else{
    //         this.$swal.close()
    //     }
    // },
    // 'q': function(newVal,oldVal) {
    //     if(newVal==''){
    //         this.viewAllUrl = this.URL_ROOT+'admin/'+this.page+'/all';
    //     }else if(newVal!=oldVal){
    //         this.viewAllUrl = this.URL_ROOT+'admin/'+this.page+'/all/'+newVal;
    //     }
    //     this.allDatas(false);
    // }
  },
};
</script>
<style scoped>
@import "~vue2-editor/dist/vue2-editor.css";

.abandoned-modal {
  background: #f5f7fb;
  height: 100%;
  overflow-y: auto;
  padding-bottom: 30px;
}

.modal-header-custom {
  position: sticky;
  top: 0;
  z-index: 10;
  background: white;
  padding: 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-modal-btn {
  border: none;
  background: #f1f1f1;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 18px;
}

.cart-card {
  background: white;
  margin: 20px;
  margin-bottom: 30px;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
}

.cart-header {
  display: flex;
  gap: 20px;
}

.cart-left {
  width: 180px;
}

.main-product-image {
  width: 180px;
  height: 180px;
  border-radius: 14px;
  object-fit: cover;
  cursor: pointer;
  border: 1px solid #eee;
  transition: 0.3s;
}

.main-product-image:hover {
  transform: scale(1.03);
}

.cart-right {
  flex: 1;
}

.product-title {
  font-weight: 700;
  margin-bottom: 10px;
}

.cart-meta {
  color: #777;
  margin-bottom: 5px;
}

.price-box {
  background: #e8fff1;
  color: #16a34a;
  padding: 10px 18px;
  border-radius: 10px;
  font-size: 22px;
  font-weight: bold;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 15px;
  margin-top: 25px;
}

.summary-item {
  background: #fafafa;
  padding: 15px;
  border-radius: 12px;
  text-align: center;
}

.summary-item span {
  display: block;
  color: #888;
  margin-bottom: 6px;
  font-size: 13px;
}

.uploaded-section {
  margin-top: 30px;
}

.section-title {
  margin-bottom: 15px;
  font-weight: 700;
}

.uploaded-images-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.uploaded-image {
  width: 140px;
  height: 140px;
  border-radius: 12px;
  object-fit: cover;
  cursor: pointer;
  border: 1px solid #eee;
  transition: 0.3s;
}

.uploaded-image:hover {
  transform: scale(1.04);
}

.options-wrapper {
  margin-top: 30px;
  border: 1px solid #e9ecef;
  border-radius: 16px;
  overflow: hidden;
  background: #fff;
}

.options-header {
  padding: 18px 22px;
  background: #f8fafc;
  border-bottom: 1px solid #ececec;
}

.options-title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
}

.options-body {
  width: 100%;
}

.option-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 22px;
  border-bottom: 1px solid #f1f5f9;
  transition: background 0.2s ease;
}

.option-row:last-child {
  border-bottom: none;
}

.option-row:hover {
  background: #fafafa;
}

.option-left {
  font-weight: 600;
  color: #334155;
  font-size: 15px;
}

.option-right {
  color: #475569;
  font-size: 15px;
  font-weight: 500;
  text-align: right;
}

.image-preview-overlay {
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.85);
  width: 100%;
  height: 100%;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.preview-image {
  max-width: 90%;
  max-height: 90%;
  border-radius: 14px;
}

.empty-cart {
  padding: 100px 20px;
  text-align: center;
  color: #888;
  font-size: 18px;
}
.cart-count-badge {
  background: #ff9800;
  color: white;
  font-size: 14px;
  padding: 4px 10px;
  border-radius: 30px;
  margin-left: 10px;
}

.days-ago-badge {
  background: #fff7ed;
  color: #ea580c;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 20px;
  margin-left: 10px;
  display: inline-block;
}

</style>
